import { Link } from "@tanstack/react-router";

const PHONE_NUMBER = "17373210551";

/**
 * Sticky mobile conversion bar for location pages.
 *
 * Mobile is where the majority of local-intent search happens, but the
 * location template's only CTAs sit in the hero and at the very bottom of a
 * 3,000+ word page — so a mobile visitor who scrolls into the content has no
 * conversion affordance in view for several screens. This pins a two-action
 * bar (call + book) to the bottom of the viewport on small screens only.
 *
 * Hidden at `md` and up, where the in-page CTAs are already reachable.
 */
export function LocationMobileBar({ city, slug }: { city: string; slug: string }) {
  return (
    <>
      {/* Spacer so the fixed bar never covers the footer's last row. */}
      <div aria-hidden className="h-20 md:hidden" />
      <nav aria-label={`${city} quick actions`} className="fixed inset-x-0 bottom-0 z-40 md:hidden border-t border-border bg-surface-1/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]">
        <div className="flex items-stretch gap-2 px-3 py-2.5">
          <a
            href={`tel:+${PHONE_NUMBER}`}
            className="flex min-h-12 flex-1 items-center justify-center gap-2 rounded-full border border-border-strong px-4 text-sm font-medium text-foreground active:scale-[0.98] transition-transform"
            aria-label={`Call Optimize Plus about ${city} SEO`}
          >
            <svg
              aria-hidden="true"
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" />
            </svg>
            Call now
          </a>
          <Link
            to="/contact/"
            search={(prev) => ({ ...prev, location: slug, service: "" })}
            className="flex min-h-12 flex-[1.2] items-center justify-center rounded-full bg-primary px-4 text-sm font-semibold text-primary-foreground active:scale-[0.98] transition-transform"
          >
            Free {city} audit →
          </Link>
        </div>
      </nav>
    </>
  );
}
